export default {"src":"/_next/static/media/discount_tag.9133e555.svg","height":189,"width":172};